import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
  customBaseURL,
  customHeaders,
  indianProjectsBaseURL,
  uaeProjectsBaseURL,
  clientCustomHeaders,
  thriweDiscoveryUrl,
  thriweDiscoveryUaeUrl,
} from '../../../../Containers/Config/index.js';
import { GET_BENEFIT_GROUP, GET_BENEFIT_GROUP_SUCCESS, GET_BENEFIT_GROUP_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitGroup({ payload }) {
  try {
    const isUaeProject = ['CBD_GOLF_V2', 'VISA_PVT', 'MASTERCARD_UAE', 'MASHREQ'].includes(Constant.PROJECT_CODE);
    const baseUrl = isUaeProject ? thriweDiscoveryUaeUrl : thriweDiscoveryUrl;

    const response = yield call(apiCall, {
      url: `${baseUrl}/v1/admin/benfit-groups`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFIT_GROUP_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFIT_GROUP_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_GROUP_ERROR, payload: error });
  }
}

export function* watchGetBenefitGroup() {
  yield takeEvery(GET_BENEFIT_GROUP, getBenefitGroup);
}

function* getBenefitGroupSagaV2() {
  yield all([fork(watchGetBenefitGroup)]);
}

export default getBenefitGroupSagaV2;
